<script lang="ts" setup>
const props = withDefaults(
  defineProps<{
    isCurrent?: boolean;
    isFirst?: boolean;
    isLast?: boolean;
    label?: string;
  }>(),
  {
    isCurrent: false,
    isFirst: false,
    isLast: false,
    label: "",
  },
);

defineEmits<{
  (e: "page-click"): void;
}>();

const aClasses = () => {
  const classes: string[] = [
    "flex",
    "items-center",
    "px-3",
    "h-8",
    "leading-tight",
    "noSelect",
  ];

  if (props.isCurrent) {
    classes.push("bg-black", "z-10", "!text-white");
  } else {
    classes.push("!text-black", "hover:bg-brand-primary", "hover:!text-white");
  }

  return classes.join(" ");
};
</script>

<template>
  <div>
    <a
      href="#"
      :class="aClasses()"
      :aria-label="label"
      @click.prevent="
        $emit('page-click');
        useScrollElementToView('productListContainer');
      "
      ><slot name="default"
    /></a>
  </div>
</template>
